import { Agent } from "./agent";
import { Base } from "./base";
import { Expense } from "./expenses";
import { Fleet } from "./fleet";
import { Job } from "./job";
import { Member } from "./members/member";
import { Quote } from "./quote";
import { Staff } from "./staff";
import { TaskComment } from "./task.comment";
import { Team } from "./team";
import { TimeSlotTask } from "./time.slot.task";
import { User } from "./user";

export interface Task extends Base {
  description: string;
  duration: number;
  startDate: string;
  endDate?: string;
  acceptDate?: string;
  period?: number;
  finishDate: string;
  jobId?: number;
  job_id?: number;
  job: Quote;
  jobs?: Job[];
  order?: Job;
  status: string;
  type: string;
  valid: boolean;
  sendToSms: boolean;
  sendToEmail: boolean;
  sendToWechat: boolean;
  sendToWhatsapp: boolean;
  arriveResidence?: string;
  breakTake?: string;
  breakBack?: string;
  leavingResidence?: string;
  arriveBackWarehouse?: string;
  leavingWarehouse?: string;
  leavingNextJob?: string;
  roomLink?: string;
  roomName?: string;
  recordings: [
    {
      link: string;
      dateCreate: Date;
      dateCompleted: Date;
    }
  ];
  userId: number;
  user: User;
  managerId: number;
  manager: User;
  milestoneEnabled?: boolean;
  leader?: User;
  leaderId?: number;
  fleets?: Fleet[];
  staffs?: Staff[];
  members?: Member[];
  memberLeaderId?: number;
  memberLeader?: Member;
  extraStaffs?: Staff[];
  sendPushNotification?: boolean;
  statusVideo?: string;
  team?: Team;
  teamId?: number;
  team_id?: number;
  rootTeamId?: number;
  comments?: TaskComment[];
  isPlaceholder?: boolean;
  name?: string;
  whatHasChanged?: string[];
  history?: string;
  timeSlots?: Partial<TimeSlotTask>[];
  teams?: Team[];
  agent?: Agent;
  agentId?: number;
  additionalInstructions: string;
  expenses?: Expense[];
}

export interface PlaceholderTask {
  companyId: number;
  name: string;
  period: TaskStartDatePeriod;
  startDate: string;
  endDate: string;
  status?: string;
  description?: string;
}

export enum TaskStartDatePeriod {
  MORNING = 1,
  AFTERNOON = 2,
  EVENING = 3,
  CUSTOM = 4,
  MULTI_DAY = 5,
  FULL_DAY = 6,
  VARIABLE_TIME = 7,
  FIXED_TIME = 8,
}

export type TaskDateProperties = "startDate" | "endDate";

export type TaskTimeControl = Pick<
  Task,
  | "id"
  | "type"
  | "leavingWarehouse"
  | "arriveBackWarehouse"
  | "arriveResidence"
  | "leavingResidence"
  | "leavingNextJob"
  | "breakTake"
  | "breakBack"
>;
